<script>
import { required, minValue, integer } from 'vuelidate/lib/validators';
import scrollMixin from '@/mixins/scrollWheelMixin';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
const WorkOrdersRepository = Repositories.get('workorders');
const WorkOrderItemsRepository = Repositories.get('workorderitems');

import ItemQuantitiesInfo from '../item-quantities-info.vue';

import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';
import Multiselect from 'vue-multiselect';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  props: {
    item: Object,
    modalId: { type: String, default: 'modify-items-modal' },
  },
  components: {
    Tooltip,
    Multiselect,
    Loading,
    ItemQuantitiesInfo,
  },
  mixins: [scrollMixin],
  data() {
    return {
      internalItem: null,
      itemQuantity: 0,
      isLoading: false,
      workOrdersList: [],
      selectedWorkOrder: null,
      workOrderItem: null,
      workOrderItemStatus: 'NULL',
    };
  },
  validations() {
    if (
      this.internalItem != null &&
      this.internalItem.quantityType == 'unitary'
    ) {
      return {
        itemQuantity: {
          required,
          minValue: minValue(this.maxDeduction * -1),
          integer,
        },
      };
    } else {
      return {
        itemQuantity: {
          required,
          minValue: minValue(this.maxDeduction * -1),
        },
      };
    }
  },
  methods: {
    modalHidden() {
      this.itemQuantity = 0;
      this.$emit('modal-closed');
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    modalShown() {
      this.internalItem = { ...this.item };
      this.itemQuantity = 0;
      this.$v.itemQuantity.$reset();

      this.selectedWorkOrder = null;
      this.workOrderItem = null;
      this.workOrderItemStatus = 'NULL';

      WorkOrdersRepository.getAll()
        .then((response) => {
          if (response.data != null && response.data.data != null) {
            this.workOrdersList = response.data.data;
          }
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    wheelInput(event) {
      this.itemQuantity = this.scrollMixinEvent(
        event,
        this.itemQuantity,
        this.maxDeduction * -1
      );
    },
    minusClicked() {
      this.itemQuantity -= 1;

      if (this.itemQuantity * -1 > this.maxDeduction) {
        this.itemQuantity = this.maxDeduction * -1;
      }
    },
    plusClicked() {
      this.itemQuantity += 1;
    },
    clearMultiSelect() {
      this.selectedWorkOrder = null;
      this.workOrderItem = null;
      this.workOrderItemStatus = 'NULL';
    },
    workOrderSelectionChanged() {
      if (this.selectedWorkOrder == null) {
        this.workOrderItemStatus = 'NULL';
        return;
      }

      this.workOrderItemStatus = 'LOADING';
      WorkOrderItemsRepository.customREST
        .getByWorkOrderAndItem(
          this.selectedWorkOrder.idPublic,
          this.item.idPublic
        )
        .then((response) => {
          if (response.data.data != null && response.data.data.length > 0) {
            this.workOrderItem = response.data.data[0];
            this.workOrderItemStatus = 'FOUND';
          } else {
            this.workOrderItemStatus = 'NOT_FOUND';
          }
        })
        .catch(() => {
          this.workOrderItemStatus = 'ERROR';
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    confirmClicked() {
      this.$v.itemQuantity.$touch();
      if (!this.$v.itemQuantity.$invalid) {
        let realQuantity = this.toFloat(this.itemQuantity);

        if (realQuantity > 0) {
          this.isLoading = true;
          ItemsRepository.actions
            .reception(
              {
                quantity: realQuantity,
                workOrderItemIdPublic:
                  this.workOrderItem != null
                    ? this.workOrderItem.idPublic
                    : null,
                workOrderIdPublic:
                  this.selectedWorkOrder != null
                    ? this.selectedWorkOrder.idPublic
                    : null,
              },
              this.item.idPublic
            )
            .then((resp) => {
              this.$emit('item-updated', resp.data);

              this.isLoading = false;
              this.closeModal();
            })
            .catch((error) => {
              this.isLoading = false;
              if (error.response.status == 409) {
                this.$toast.warningToast(
                  this.$t('errors.wasDesyncedTryAgainBulk')
                );
                this.reloadItem();
              } else {
                this.$toast.errorToast(this.$t('errors.errorLoading'));
              }
            });
        } else {
          this.isLoading = true;
          ItemsRepository.actions
            .consume(
              {
                quantity: realQuantity * -1,
                workOrderItemIdPublic:
                  this.workOrderItem != null
                    ? this.workOrderItem.idPublic
                    : null,
                workOrderIdPublic:
                  this.selectedWorkOrder != null
                    ? this.selectedWorkOrder.idPublic
                    : null,
              },
              this.item.idPublic
            )
            .then((resp) => {
              this.$emit('item-updated', resp.data);

              this.isLoading = false;
              this.closeModal();
            })
            .catch((error) => {
              this.isLoading = false;
              if (error.response.status == 409) {
                this.$toast.warningToast(
                  this.$t('errors.wasDesyncedTryAgainBulk')
                );
                this.reloadItem();
              } else {
                this.$toast.errorToast(this.$t('errors.errorLoading'));
              }
            });
        }
      }
    },
    reloadItem() {
      this.isLoading = true;
      ItemsRepository.get(this.item.idPublic)
        .then((response) => {
          this.internalItem = response.data;

          this.$emit('item-updated', this.internalItem);

          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    itemUpdated(item) {
      this.internalItem = item;
      this.$emit('item-updated', this.internalItem);
    },
  },
  computed: {
    maxDeduction() {
      if (this.internalItem != null) {
        if (this.workOrderItem != null) {
          return this.toFloat(
            this.internalItem.totalQuantity -
              this.internalItem.reservedQuantity +
              this.workOrderItem.reservedQuantity
          );
        } else {
          return this.toFloat(
            this.internalItem.totalQuantity - this.internalItem.reservedQuantity
          );
        }
      } else {
        return 0;
      }
    },
    toReserve() {
      if (this.itemQuantity > 0) {
        return this.itemQuantity;
      }

      return 0;
    },
    toConsume() {
      if (this.itemQuantity < 0) {
        return this.itemQuantity * -1;
      }

      return 0;
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      :id="modalId"
      :title="item != null ? item.name : ''"
      scrollable
      hide-footer
      size="xl"
      @shown="modalShown()"
      @hide="modalHidden()"
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>

      <div v-if="internalItem != null" class="wrapper">
        <div class="header">
          <ItemQuantitiesInfo
            class="ml-3"
            :item="internalItem"
            :show-availables="false"
            @item-updated="itemUpdated"
            @reload-item="reloadItem"
          />
        </div>

        <div class="right-column customScrollbar">
          <b-form-group :label="$t('workOrders.workOrders')">
            <multiselect
              class="no_overflow"
              ref="woMultiSelect"
              :max-height="200"
              :max-width="200"
              v-model="selectedWorkOrder"
              @input="workOrderSelectionChanged"
              :options="workOrdersList"
              :show-labels="false"
              :show-arrow="true"
              label="name"
              track-by="idPublic"
              :placeholder="$t('general.pickAValue')"
              ><template v-slot:noOptions>
                {{ $t('general.noResult') }}
              </template>

              <template slot="singleLabel" slot-scope="{ option }">
                <div class="flex-box">
                  <div>{{ option.name }}</div>
                  <div
                    class="flex-push"
                    style="
                      padding-left: 10px;
                      padding-right: 5px;
                      cursor: pointer;
                    "
                    @mousedown.prevent.stop="clearMultiSelect()"
                  >
                    <i class="fas fa-times text-secondary"></i>
                  </div>
                </div>
              </template>
            </multiselect>

            <div v-if="workOrderItemStatus != 'NULL'">
              <i
                v-if="workOrderItemStatus == 'LOADING'"
                class="bx bx-loader-alt bx-spin text-warning"
                style="font-size: 2em"
              >
              </i>
              <div v-else-if="workOrderItemStatus == 'NOT_FOUND'">
                {{ $t('general.notFound') }}
              </div>
              <div v-else-if="workOrderItem != null">
                <ul style="list-style-type: none; padding: 0">
                  <li>
                    {{
                      $t('items.quantity') +
                      ': ' +
                      workOrderItem.totalQuantity.toString()
                    }}
                  </li>
                  <li>
                    <ul style="list-style-type: none">
                      <li :class="{ 'text-success': toReserve > 0 }">
                        {{
                          $t('items.toReserve') +
                          ': ' +
                          (
                            workOrderItem.totalQuantity -
                            workOrderItem.consumedQuantity -
                            workOrderItem.reservedQuantity -
                            toReserve
                          ).toString()
                        }}
                      </li>
                      <li :class="{ 'text-danger': toConsume > 0 }">
                        {{
                          $t('items.toConsume') +
                          ': ' +
                          (
                            workOrderItem.totalQuantity -
                            workOrderItem.consumedQuantity -
                            toConsume
                          ).toString()
                        }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </b-form-group>
        </div>

        <div class="main">
          <div class="flex-vertical-center" style="font-size: 1.3em">
            <b-form-group style="margin-bottom: 10px">
              <b-form-input
                class="custom-input"
                type="number"
                ref="add-items-modal"
                v-model="itemQuantity"
                :step="internalItem.quantityType == 'unitary' ? '1' : '.00001'"
                :min="maxDeduction * -1"
                :class="{
                  'is-invalid': $v.itemQuantity.$error,
                }"
                @wheel.prevent="wheelInput($event)"
                @keydown.enter.prevent="receptItems"
                tabindex="-1"
                :placeholder="$t('items.quantity')"
              ></b-form-input>
              <Tooltip :validations="$v.itemQuantity" />
            </b-form-group>

            <small class="text-muted">
              {{ $t('items.availableQuantity') + ': ' + maxDeduction }}
            </small>

            <div class="flex-center-align" style="font-size: 1.3em">
              <div
                class="custom-plus-minus-button flex-vertical-align"
                :style="
                  itemQuantity == maxDeduction * -1 ? 'box-shadow: none' : ''
                "
                @click="minusClicked()"
              >
                <i
                  class="fas fa-minus"
                  :class="
                    itemQuantity == maxDeduction * -1
                      ? 'text-secondary'
                      : 'text-danger'
                  "
                ></i>
              </div>
              <div
                class="custom-plus-minus-button flex-vertical-align"
                @click="plusClicked()"
              >
                <i class="fas fa-plus text-success"></i>
              </div>
            </div>

            <b-button
              size="lg"
              :disabled="itemQuantity == 0"
              style="width: 230px; margin-top: 20px"
              :variant="
                itemQuantity > 0
                  ? 'success'
                  : itemQuantity < 0
                  ? 'danger'
                  : 'secondary'
              "
              @click="confirmClicked()"
            >
              {{ $t('general.confirm') }}
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
.no_overflow .multiselect__content-wrapper {
  max-width: 100%;
  border-top: 1px solid #e8e8e8;
}

.multiselect--active .multiselect__tags {
  border-bottom: none;
}
</style>
<style scoped>
.custom-input {
  border: none !important;
  border-bottom: 1px solid rgb(233, 233, 233) !important;
  border-radius: 0 !important;
  max-width: 200px;
  text-align: center;
  font-size: 2.5em;
  padding: 20px 10px;
  line-height: 100px;
  height: 100px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.custom-plus-minus-button {
  border: 2px solid rgb(214, 214, 214);
  border-radius: 15px;
  padding: 5px;
  width: 100px;
  height: 100px;
  margin: 15px;
  line-height: 50px;
  color: white;
  font-weight: bold;
  font-size: 2em;
  text-align: center;
  box-shadow: 1px 1px 3px rgb(207, 207, 207);
  cursor: pointer;
}

.wrapper {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 300px 1fr 300px;
  background-color: #fff;
  color: #444;
}

/* Grid */
.header {
  grid-column: 1 / span 2;
}
.right-column {
  grid-column: 3;
  grid-row: 1 / span 2;
}
.main {
  grid-column: 2;
  grid-row: 2;
}
</style>